import { render, staticRenderFns } from "./TableIvPrices.vue?vue&type=template&id=2fcd56b7"
import script from "./TableIvPrices.vue?vue&type=script&lang=js"
export * from "./TableIvPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports